import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class PaymentAccountRef extends DataModel {
  static readonly TYPE_ID: string = 'b2c09b1d9305489888c06f7a001660ad';

  constructor(
    public readonly name: string,
    public readonly uniqueId: string,
    public readonly organizationId: string,
  ) {
    super();
  }

  get $typeId() {
    return PaymentAccountRef.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PaymentAccountRef {
    return new PaymentAccountRef(
        MapUtils.get<string>(map, 'name'),
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'organizationId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'name': this.name,
      'uniqueId': this.uniqueId,
      'organizationId': this.organizationId,
    };
  }

  clone(): this {
    return new PaymentAccountRef(
        this.name,
        this.uniqueId,
        this.organizationId,
    ) as this;
  }

  isSame(other: PaymentAccountRef): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.name === this.name &&
        other.organizationId === this.organizationId;
  }
}

export class PaymentAccountRefBuilder extends DataModelBuilder<PaymentAccountRef> {
  build(context: SerializationContext, map: SerializedData): PaymentAccountRef {
    return PaymentAccountRef.fromMap(context, map);
  }
}
